import * as Preact from "preact"
import "@frog/source/views/components/Cursor.less"
import App from "@frog/source/models/App.js"
import Zone from "@frog/source/models/Zone.js"
import Dev from "@frog/source/models/dev/Dev.js"
import World from "@frog/source/models/World.js"
import UnitSprite from "@frog/source/views/components/UnitSprite.jsx"
import UnitTemplateSprite from "@frog/source/views/components/UnitTemplateSprite.jsx"

export default class Cursor {
    render() {
        const stage = this.props.stage
        if(stage == undefined) return
        if(stage.dialogue != undefined) return
        // if(App.game.chapter.selection.position.z == 0) {
        //     return
        // }
        if(App.options.disableActionUI == true) return
        if(World.isOutOfBounds(stage.world, App.game.chapter.selection.position)) {
            return
        }

        if(Dev.inProtoMode == false
        && Zone.isInBounds(stage.encounters[stage.currentEncounterKey]?.zone, App.game.chapter.selection.position) == false) {
            return
        }

        if(Dev.inProtoMode == false
        && World.isEmptyPosition(stage.world, App.game.chapter.selection.position)) {
            return
        }

        if(Dev.selectedTemplate != undefined) {
            return (
                <div class="Cursor" style={this.style}>
                    <div class="Sprite" isHovered={this.isHovered}/>
                    <UnitTemplateSprite unitTemplate={Dev.selectedTemplate}/>
                </div>
            )
        }
        if(Dev.devSelection.selectedSpotTemplate != undefined) {
            let style = ""
            if(Dev.tagColors[Dev.devSelection.selectedSpotTemplate.tag] != undefined) {
                style = "background-color:" + Dev.tagColors[Dev.devSelection.selectedSpotTemplate.tag]
            }
            return (
                <div class="Cursor" style={this.style}>
                    <div class="Sprite" isHovered={this.isHovered}/>
                    <div class="Spot" style={style}/>
                </div>
            )
        }

        return (
            <div class="Cursor" style={this.style}>
                <div class="Sprite" isHovered={this.isHovered}/>
            </div>
        )
    }
    get isHovered() {
        return App.game.chapter.selection.hoveredUnitKey != undefined
    }
    get style() {
        const selection = App.game.chapter.selection

        return {
            "left": selection.position.x + "em",
            "top": selection.position.y + "em",
        }
    }
}
